import { WebStorageStateStore } from "oidc-client-ts";
//const dotenv = require("dotenv");
//dotenv.config();
//const oidcConfigUrl = backendUrls.oidcConfigUrl;

const selfUrl = window.location.origin;
//const selfUrl = 'https://localhost:3001';
//const selfUrl = "https://singlepdf-qa-ui.azurewebsites.net";

//const oidcConfigVar = await fetch(oidcConfigUrl + `customerName=${sessionStorage.getItem('customerName')}`)

export const oidcConfig = {
  // authority: process.env.AUTHORITY,   // This is the identity provider, in this case SAP IAS //TODO: get from config
  // authority: oidcConfigVar.authority,
  //client_id: process.env.CLIENT_ID,      // This is the public key to the Oauth2 flow //TODO: get from config
  //client_id: oidcConfigVar.client_id,
  redirect_uri: selfUrl + "/callback",                    // This is the URI that is registered in SAP IAS
  response_type: "code",                                  // It's a constant value of 'code', no other OIDC flow is supported
  scope: "openid profile email",                          // It's a constant value for OIDC flow
  post_logout_redirect_uri: selfUrl + "/logout",          // This is the URI where the user should be redirected after logout
  userStore: new WebStorageStateStore({ store: window.localStorage }), //Store the user info in a local storage, te prevent unnecessary re-authentication    
};